import { SavedLocation } from '../types';

/**
 * Export saved locations to a file
 */
export const exportToFile = (locations: SavedLocation[]): void => {
  try {
    const data = JSON.stringify(locations, null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `vineyard-shadow-tool-locations-${new Date().toISOString().split('T')[0]}.json`;
    
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting to file:', error);
    throw new Error('Failed to export locations');
  }
};

/**
 * Import saved locations from a file
 */
export const importFromFile = (): Promise<SavedLocation[]> => {
  return new Promise((resolve, reject) => {
    try {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/json';
      
      input.onchange = (event) => {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (!file) {
          reject(new Error('No file selected'));
          return;
        }
        
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const contents = e.target?.result as string;
            const locations = JSON.parse(contents) as SavedLocation[];
            resolve(locations);
          } catch (error) {
            reject(new Error('Invalid JSON file'));
          }
        };
        reader.onerror = () => {
          reject(new Error('Error reading file'));
        };
        reader.readAsText(file);
      };
      
      input.click();
    } catch (error) {
      reject(new Error('Failed to import locations'));
    }
  });
}; 